import { ThemeOptions } from '@mui/material';
import { tokens } from '../../../theme/generated/tokens';

export const ratioProgressBarTheme: ThemeOptions['components'] = {
  DsRatioProgressBar: {
    styleOverrides: {
      // Slots
      root: {
        display: 'flex',
        position: 'relative',
        overflow: 'visible',
        border: `1px solid ${tokens.theme.border.structural.inverse}`,
        boxSizing: 'border-box',
        backgroundColor: tokens.theme.bg.structural.surfaceRaised,
        // Clip only the bars, not the benchmark tick
        '& .DsRatioProgressBar-BarContainer': {
          overflow: 'hidden',
        },
      },
      barContainer: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        borderRadius: 'inherit',
      },
      bar: {
        borderRadius: 'inherit',
        backgroundColor: tokens.theme.fg.structural.primary,
      },
      benchmark: {
        position: 'absolute',
        top: '50%',
        width: 1,
        transform: 'translateX(-50%) translateY(-50%)',
        backgroundColor: tokens.theme.border.structural.inverse,
        pointerEvents: 'none',
        zIndex: 1,
      },
      // Modifiers
      lg: {
        height: 8,
        borderRadius: tokens.theme.radius.sm,
        '& .DsRatioProgressBar-Benchmark': {
          // 8px bar + 4px overflow top + 4px overflow bottom = 16px
          height: 16,
        },
      },
      md: {
        height: 4,
        borderRadius: tokens.theme.radius.xs,
        '& .DsRatioProgressBar-Benchmark': {
          // 4px bar + 2px overflow top + 2px overflow bottom = 8px
          height: 8,
        },
      },
      sm: {
        height: 2,
        borderRadius: 1,
        '& .DsRatioProgressBar-Benchmark': {
          // 2px bar + 3px overflow top + 3px overflow bottom = 8px
          height: 8,
        },
      },
      noBorders: {
        border: 'none',
      },
    },
  },
};
